import React, { useState, useEffect } from "react";
import { Select, Tag, Modal, Tooltip, Spin } from "antd";
import { withAuth } from "@salespark/api-client-v2";
import { createAPIClientAuth } from "utils/helper";

const { Option } = Select;

const EntitiesList = ({ authData }) => {
  const apiHandler = withAuth(createAPIClientAuth(authData));
  const [isLoading, setIsLoading] = useState(false);
  const [selectionModal, setSelectionModal] = useState({ visible: false, data: null });
  const [selectedEntity, setSelectedEntity] = useState(null);

  useEffect(() => {
    if (authData?.active_entity) {
      setSelectedEntity(authData.active_entity);
    }
  }, [authData]);

  if (!authData) return <></>;
  if (!authData?.entities) return <></>;
  if (!authData?.active_entity) return <></>;
  if (authData?.entities?.length === 0) return <></>;

  const changeHandler = (value) => {
    const allEntities = [
      ...authData.entities,
      {
        _id: authData.id,
        email: authData.email,
        id: authData.id,
        name: authData.name,
        picture: authData.picture,
        type: "self",
      },
    ];

    const data = allEntities.find((ent) => ent.id === value);

    // Check if the selected entity is the same as the current producer
    if (data.id === authData.id) {
      confirmChange(data);
      return;
    }

    setSelectionModal({ visible: true, data: data });
  };
  const confirmChange = async (data) => {
    try {
      const actualActiveEntity = selectedEntity;
      setIsLoading(true);
      setSelectedEntity(data);

      const updateResponse = await apiHandler.put("/producers/change-active-entity", { active_entity: data.id });
      if (!updateResponse.status) {
        setIsLoading(false);
        Modal.error({
          title: "Erro ao mudar de entidade",
          content: "Ocorreu um erro ao mudar de entidade. Pode ser um erro temporário. Tenta novamente mais tarde.",
        });
        setSelectedEntity(actualActiveEntity);
        return;
      }

      window.location.assign("/dashboard");

      // Error handling
    } catch (error) {
      setIsLoading(false);
      setSelectedEntity(authData.active_entity);
      Modal.error({
        title: "Erro ao mudar de entidade",
        content: "Ocorreu um erro ao mudar de entidade. Pode ser um erro temporário. Tenta novamente mais tarde.",
      });
    }
  };

  return (
    <Spin spinning={isLoading}>
      <div className="mr-2">
        <Tooltip
          title={selectedEntity?.type === "self" ? "Estás a trabalhar na tua conta pessoal." : `Estás a trabalhar na conta da entidade ${selectedEntity?.name}`}
          placement="right"
        >
          <Select
            style={{ width: 250 }}
            size="small"
            value={selectedEntity?.id}
            onChange={changeHandler}
            className={selectedEntity?.type === "self" ? null : "teams-entity-self"}
          >
            <Option key={authData.id} value={authData.id}>
              {authData.name} <small className="text-muted">({authData.id})</small>
              <Tag color="geekblue" className="smallTag">
                A tua conta
              </Tag>
            </Option>
            {authData?.entities.map((entity) => (
              <Option key={entity.id} value={entity.id}>
                {entity.name} <small className="text-muted">({entity.id})</small>
              </Option>
            ))}
          </Select>
        </Tooltip>
      </div>
      <Modal
        width={600}
        title="Alterar Entidade"
        visible={selectionModal.visible}
        okText="Sim, alterar entidade ativa"
        onOk={() => {
          confirmChange(selectionModal.data);
          setSelectionModal({ visible: false, data: null });
        }}
        onCancel={() => setSelectionModal({ visible: false, data: null })}
      >
        <>
          <p>
            Estás prestes a mudar a entidade ativa para:
            <br />
            <strong>
              {selectionModal.data?.name} (ID: {selectionModal.data?.id})
            </strong>
            .
          </p>

          <p>
            A partir deste momento, todas as ações que efetuares serão realizadas <strong>em nome desta entidade</strong>, de acordo com as permissões que te
            foram atribuídas.
          </p>

          <p>
            Entidade associada ao e-mail:
            <br />
            <strong>{selectionModal.data?.email}</strong>
          </p>

          <p style={{ opacity: 0.7, fontSize: "0.9em" }}>Podes voltar à tua entidade a qualquer momento através do seletor de entidade.</p>
        </>
      </Modal>
    </Spin>
  );
};

export default EntitiesList;
